import type { SVGProps } from "react"
import { Ref, forwardRef } from "react"

const StarIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="44" height="42" viewBox="0 0 44 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.2864 1.84744C21.0637 0.555804 22.9363 0.555803 23.7136 1.84744L29.4629 11.4008C29.7422 11.8649 30.1977 12.1958 30.7253 12.318L41.5877 14.8338C43.0564 15.1739 43.635 16.9548 42.6468 18.0932L35.3376 26.5133C34.9826 26.9223 34.8086 27.4578 34.8555 27.9973L35.8195 39.1055C35.9498 40.6074 34.4349 41.7081 33.0468 41.12L22.7802 36.7705C22.2815 36.5593 21.7185 36.5593 21.2198 36.7705L10.9532 41.12C9.56511 41.7081 8.05015 40.6074 8.18049 39.1055L9.14454 27.9973C9.19137 27.4578 9.01738 26.9223 8.66236 26.5133L1.35319 18.0932C0.36497 16.9548 0.943632 15.1739 2.41226 14.8338L13.2747 12.318C13.8023 12.1958 14.2578 11.8649 14.5371 11.4008L20.2864 1.84744Z"
      fill={props.fill}
    />
  </svg>
)
const ForwardRef = forwardRef(StarIcon)
export default ForwardRef
